import { joinedValuesSeparator } from '@/ts/DefaultTableConfigs';

export default class DeadlineOfferData {
    public id: number;
    public project: string;
    public sentDate: string;
    public deadLineDate: string;
    public moveInDate: string;
    public unitId: string;
    public propertyId: number;
    public address: string;
    public type: string;
    public applicants: number;
    public groups: string[];
    public createdBy: string;

    constructor(
        id: number,
        project: string,
        sentDate: string,
        deadLineDate: string,
        moveInDate: string,
        unitId: string,
        propertyId: number,
        address: string,
        type: string,
        applicants: number,
        groups: any,
        createdBy: string,
    ) {
        this.id           = id;
        this.project      = project;
        this.unitId       = unitId;
        this.propertyId   = propertyId;
        this.address      = address;
        this.type         = type;
        this.applicants   = applicants;
        this.groups       = groups.join(joinedValuesSeparator);
        this.createdBy    = createdBy;
        this.sentDate     = sentDate;
        this.moveInDate   = moveInDate;
        this.deadLineDate = deadLineDate;
    }
}
